import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { store } from "@/lib/storage";

const AuthCtx = createContext(null);

async function syncLocalProfileToServer() {
  const local = store.getProfile();
  if (!local) return null;
  try {
    // Récupère le profil serveur ; s'il est vide, on pousse le local
    const { data } = await api.get("/profile");
    if (!data.profile) {
      await api.put("/profile", { data: local });
      return local;
    }
    // Serveur prioritaire : on récupère les préférences persistées
    store.setProfile(data.profile);
    return data.profile;
  } catch { return null; }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=inconnu, false=anon, obj=connecté
  const [entitlement, setEntitlement] = useState({ premium: false, status: "none" });
  const [config, setConfig] = useState({ configured: false, prices: null });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      try {
        const { data: ent } = await api.get("/subscription/status");
        setEntitlement(ent);
      } catch { setEntitlement({ premium: false, status: "none" }); }
    } catch {
      setUser(false);
      setEntitlement({ premium: false, status: "none" });
    }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/subscription/config");
        setConfig(data);
      } catch (e) { console.warn("Config abonnement indisponible :", e?.message); }
      await refresh();
    })();
  }, [refresh]);

  async function login(email, password) {
    const { data } = await api.post("/auth/login", { email, password });
    setUser({ id: data.id, email: data.email });
    await syncLocalProfileToServer();
    await refresh();
  }
  async function register(email, password) {
    const { data } = await api.post("/auth/register", { email, password });
    setUser({ id: data.id, email: data.email });
    await syncLocalProfileToServer();
    await refresh();
  }
  async function logout() {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("Déconnexion serveur échouée :", e?.message); }
    setUser(false);
    setEntitlement({ premium: false, status: "none" });
  }

  return (
    <AuthCtx.Provider value={{ user, entitlement, config, login, register, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
